import {
  createReportTargetCondition,
  createReportTargetStatus,
  createReportTargetValue,
  EReportTargetComparisonOperators,
  IReportTargetValue
} from '@opengov/reporting-types';
import { freeze, produce } from 'immer';

import { composeStateMachine } from '../../../../module';
import { report as reportLocale } from '../../locale';

export const ReportTargetInitialState = freeze(
  {
    condition: createReportTargetCondition({
      value: createReportTargetValue({
        text: ''
      }),
      status: createReportTargetStatus({
        text: reportLocale.setTargetModal.onTarget
      })
    }),
    secondCondition: createReportTargetCondition({
      value: createReportTargetValue({
        text: ''
      }),
      status: createReportTargetStatus({
        text: reportLocale.setTargetModal.onTrack
      })
    }),
    elseStatus: createReportTargetStatus({
      text: reportLocale.setTargetModal.needsFocus
    })
  },
  true
);

export const reportTargetState = composeStateMachine('report-target', ReportTargetInitialState, (compose) => ({
  resetTargetState: compose.payloadlessAction(() => ReportTargetInitialState),
  updateConditionOperator: compose.action((state, payload: EReportTargetComparisonOperators) =>
    produce(state, (draftState) => {
      draftState.condition.operator = payload;
    })
  ),
  updateConditionValue: compose.action((state, payload: IReportTargetValue) =>
    produce(state, (draftState) => {
      draftState.condition.value = payload;
    })
  ),
  updateConditionStatusText: compose.action((state, payload: string) =>
    produce(state, (draftState) => {
      draftState.condition.status.text = payload;
    })
  ),
  updateSecondConditionValue: compose.action((state, payload: IReportTargetValue) =>
    produce(state, (draftState) => {
      draftState.secondCondition.value = payload;
      draftState.secondCondition.operator = state.condition.operator;
    })
  ),
  updateSecondConditionStatusText: compose.action((state, payload: string) =>
    produce(state, (draftState) => {
      draftState.secondCondition.status.text = payload;
    })
  ),
  updateElseStatusText: compose.action((state, payload: string) =>
    produce(state, (draftState) => {
      draftState.elseStatus.text = payload;
    })
  )
}));

export const {
  actions: reportTargetActions,
  actionCreators: reportTargetActionCreators,
  selector: reportTargetSelector,
  reducer: reportTargetReducer
} = reportTargetState;
